import { motion } from "framer-motion"
import { GraduationCap, Award, BookCheck, Sparkles } from "lucide-react"
import "./Scholarships.css"

const Scholarships = ({ countryData }) => {
  const scholarshipsData = countryData?.scholarships
  const scholarships = Array.isArray(scholarshipsData)
    ? scholarshipsData
    : scholarshipsData
      ? [scholarshipsData]
      : []

  const icons = [GraduationCap, Award, BookCheck, Sparkles]

  return (
    <div className="scholarships-container">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Scholarships to Study in {countryData?.name}
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        viewport={{ once: true }}
        className="scholarships-intro"
      >
        Unlock your potential with financial support. Various scholarships are offered by governments, universities, and private organizations to empower international students.
      </motion.p>

      <div className="scholarships-grid">
        {scholarships.map((scholarship, index) => {
          const Icon = icons[index % icons.length]
          return (
            <motion.a
              key={index}
              href={scholarship.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              viewport={{ once: true }}
              className="scholarship-item"
            >
              <div className="scholarship-icon">
                <Icon size={24} />
              </div>
              <h3 className="scholarship-name">
                {scholarship.name}
              </h3>
            </motion.a>
          )
        })}
      </div>
    </div>
  )
}

export default Scholarships
